import React, { useContext, useState } from "react";
import Card from "canvas-core-react/lib/Card";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import TextField from "canvas-core-react/lib/TextField";
import { CoachContext } from "../../context";
import TextBody from "canvas-core-react/lib/TextBody";
import { ButtonOk } from "../buttonOk";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import { tagCoach } from "../../utils/utils";

export interface TitleTextInputProps {
  title: string;
  content: string;
  inputs: {
    name: string;
    title: string;
    group?: string;
    subGroup?: string;
  }[];
  typeValue: string;
  tag?: any;
  step?: number;
  onClickParent?: any;
  index?: number;
  specialButton: boolean;
}

export const TitleTextInput = ({
  title,
  content,
  inputs,
  typeValue,
  tag,
  step = 0,
  onClickParent,
  index = 0,
  specialButton = false,
}: TitleTextInputProps) => {
  const [inputValue, setInputValue] = useState("");
  const { saveValue, values } = useContext(CoachContext);
  const [stateValue, setStateValue] = useState<any>({});
  const [disabledBtn, setDisabledBtn] = useState<boolean>(true);
  const [disabledTxt, setDisabledTxt] = useState<boolean>(false);

  /* istanbul ignore next */
  const onTrigger = (
    event: any,
    name: string,
    titleInput: string,
    group: string,
    subGroup: string
  ) => {
    saveValue(name, titleInput, inputValue.replaceAll(".", ""), group, subGroup);
    setInputValue(inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    setStateValue({ name: "input", error: "" });
    setDisabledTxt(true);
    setDisabledBtn(true);
    onClickParent(event);

    if (tag !== undefined)
      tagCoach(tag.step, "", tag.dimension3, typeValue === "number" ? inputValue : "1");
  };

  /* istanbul ignore next */
  const handleChange = (event: any) => {
    if (event.target.value === "") {
      setInputValue("");
      setStateValue({ name: "input", error: "no puede estar vacío." });
      setDisabledBtn(true);

    } else {
      if (typeValue === "number") {

        let num = parseInt(event.target.value
          .replaceAll('.', ''));


        if (num.toString().match(/^-?\d*\.?\d*$/)) {
          if (event.target.value.length < 16) {
            setInputValue(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
            setStateValue({ name: "input", error: "" });
            setDisabledBtn(false);
          }
          else {
            setInputValue(num.toString().substring(0, 14).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
            setStateValue({ name: "input", error: "maximo 15 digitos." });
            // setDisabledBtn(true);
          }
        } else {
          setStateValue({ name: "input", error: "ingrese solo números." });
          setDisabledBtn(true);

        }
      } else if (typeValue === "string") {
        if (event.target.value.match(/^[aA-zZ\s]+$/)) {
          setInputValue(event.target.value);
          setStateValue({ name: "input", error: "" });
          setDisabledBtn(false);
        } else {
          setStateValue({ name: "input", error: "ingrese solo letras." });
          setDisabledBtn(true);
        }
      }
    }
  };
  return (
    <Card>
      {title && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextSubtitle component="span">{title}</TextSubtitle>
            </Column>
          </Row>
        </Margin>
      )}
      {content && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextBody component="span">{content}</TextBody>
            </Column>
          </Row>
        </Margin>
      )}
      {inputs.length > 0 && (
        <Margin xs={12} sm={12} md={12} lg={12}>
          {inputs.map((value, valuePos) => {
            return (
              <div key={valuePos}>
                <Row>
                  <Column xs={4} sm={8} md={12} lg={12}>
                    <TextField
                      id={value.name}
                      label={value.title}
                      onChange={handleChange}
                      data-testid="inputField"
                      placeholder={typeValue === "number" ? "$" : ""}
                      disabled={disabledTxt}
                      value={inputValue}
                    />
                    <div>{stateValue.error}</div>
                  </Column>
                </Row>
                <Margin xs={48} sm={48} md={48} lg={48} side="top">
                  {!specialButton ? (
                    <Row justifyContent="center">
                      <Column xs={4} sm={8} md={12} lg={12}>
                        <ButtonOk
                          title="Continuar"
                          onClick={(event) =>
                            onTrigger(
                              event,
                              value.name,
                              value.title,
                              value.group ? value.group : "",
                              value.subGroup ? value.subGroup : ""
                            )
                          }
                          inputTitle={value.title}
                          inputValue={inputValue}
                          index={index}
                          step={step}
                          disabled={disabledBtn}
                          isLarge={true}
                        />
                      </Column>
                    </Row>
                  ) : (
                    <Row justifyContent="end">
                      <ContinueButton
                        data-input={inputValue}
                        data-title={value.title}
                        data-index={index}
                        data-step={step}
                        disabled={disabledBtn}
                        onClick={(event) => {
                          onTrigger(
                            event,
                            value.name,
                            value.title,
                            value.group ? value.group : "",
                            value.subGroup ? value.subGroup : ""
                          );
                        }}
                      >
                        Continuar
                      </ContinueButton>
                    </Row>
                  )}
                </Margin>
              </div>
            );
          })}
        </Margin>
      )}
    </Card>
  );
};
